<mat-slide-toggle
  color="primary"
  class="no-margin-checkbox"
  [formControl]="formControl"
  [disabled]="temporarilyDisabled"
  (ngModelChange)="onChange()"
></mat-slide-toggle>
